import React from "react";
import cn from "clsx";

export interface ErrorsProps {
  classNamePrefix?: string;
  className?: string;
  errors?: React.ReactNodeArray;
}

export default function Errors({
  errors,
  className,
  classNamePrefix
}: ErrorsProps) {
  if (!errors || !errors.length) {
    return null;
  }

  return (
    <ul
      className={cn(
        "errors",
        !!classNamePrefix && `${classNamePrefix}-errors`,
        className
      )}
    >
      {errors.map((error, index) => (
        <li
          key={index}
          className={cn(
            "error",
            !!classNamePrefix && `${classNamePrefix}-error`
          )}
        >
          {error}
        </li>
      ))}
    </ul>
  );
}
